module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="vertical-guideline-inner"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/guideline/VerticalGuidelineView.tpl
// module id = 2987
// module chunks = 0